import { ErrorString, InvalidOperationException } from "../../shared/index.js";
import { nextIterationAsync } from "./_nextIterationAsync.js";
import { typeDataToArray } from "./_typeDataToArray.js";
export const maxAsync = async (source, selector) => {
    const dataFunc = nextIterationAsync(source, selector);
    const maxInfo = await typeDataToArray(dataFunc);
    if (maxInfo.length === 0) {
        throw new InvalidOperationException(ErrorString.NoElements);
    }
    return Math.max.apply(null, maxInfo);
};
